import { SetState } from 'zustand';
import { IMeta, IPaginate, IUIState, Reducers, State, Store } from './type';
import { IPermission } from '../interfaces/global';

export const reducers = (set: SetState<Store>): Reducers => ({
  setPaginate: (paginate: Partial<IPaginate>) =>
    set((state: State) => ({
      paginate: {
        ...state.paginate,
        ...paginate
      }
    })),
  setData: (data: IPermission[]) =>
    set(() => ({
      data: [...data]
    })),

  setUi: (ui: Partial<IUIState>) =>
    set((state: State) => ({
      ui: {
        ...state.ui,
        ...ui
      }
    }))
});
